import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import color from "../_style/color";

const Relative = styled.div`
  position: relative;
`;

const ComponentTrigger = styled.div`
  width: 100%;
  display: inline-block;
  cursor: pointer;
`;

const PopoverDisplay = styled.div`
  display: ${({ isVisible }) => (isVisible ? "inline-block" : "none")};
`;

const PopoverContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  border: 1px solid ${color.lowgray};
  border-radius: 2px;
`;
const Popover = ({ children, componentTrigger }) => {
  const [isPopoverVisible, setVisibilityPopover] = useState(false);
  const popoverRef = useRef();
  const componentTriggerRef = useRef();

  useEffect(() => {
    const onNavExpandClick = (e) => {
      if (componentTriggerRef.current.contains(e.target)) {
        return setVisibilityPopover(!isPopoverVisible);
      }
      if (popoverRef.current.contains(e.target)) {
        return setVisibilityPopover(true);
      }
      return setVisibilityPopover(false);
    };

    document.addEventListener("click", onNavExpandClick);
    // Clean eventlistener when unmount component
    return () => {
      document.removeEventListener("click", onNavExpandClick);
    };
  }, [isPopoverVisible]);

  return (
    <Relative>
      <ComponentTrigger ref={componentTriggerRef} isActive={isPopoverVisible}>
        {componentTrigger(isPopoverVisible)}
      </ComponentTrigger>
      <PopoverDisplay ref={popoverRef} isVisible={isPopoverVisible}>
        {children}
      </PopoverDisplay>
    </Relative>
  );
};

export { PopoverContainer };
export default Popover;
